// TeacherContext.js
import useTeacherSession from 'common/hooks/useTeacherSession'
import { TeacherSession } from 'common/utils/types/teacher-session'
import React, {
  createContext,
  useContext,
  useState,
  useMemo,
  useEffect,
} from 'react'

export const TeacherContext = createContext<{
  teacherSession: TeacherSession
}>(null)

export const useTeacherContext = () => useContext(TeacherContext)

export function TeacherProvider({ children }) {
  const [teacherSession, setTeacherSession] = useState<TeacherSession>()

  const { session } = useTeacherSession()
  useEffect(() => {
    setTeacherSession(session)
  }, [session])

  const value = useMemo(
    () => ({
      teacherSession,
    }),
    [teacherSession]
  )

  return (
    <TeacherContext.Provider value={value}>{children}</TeacherContext.Provider>
  )
}
